// Parse/serialize helpers for the client-written `experiment_assignments` cookie
// (see constants.ts). Format mirrors the `experimentVariant` forced cookie: flat
// `id:variant` pairs joined by commas — e.g. `flagA:treatment,flagB:control`. No
// next/headers import here, so both the client provider (writer) and the server
// store (reader) can share it.

export function parseAssignmentsCookie(
  value: string | undefined,
): Record<string, string> {
  const byName: Record<string, string> = {};
  if (!value) return byName;

  for (const token of value.split(",")) {
    const sep = token.indexOf(":");
    if (sep === -1) continue;
    const name = token.slice(0, sep).trim();
    if (name) byName[name] = token.slice(sep + 1).trim();
  }
  return byName;
}

export function serializeAssignmentsCookie(
  byName: Record<string, string>,
): string {
  return Object.entries(byName)
    .map(([name, variation]) => `${name}:${variation}`)
    .join(",");
}
